import { useState, useEffect, useCallback } from 'react';
import './PinLock.css';

const CORRECT_PIN = '2684';

function PinLock({ onUnlock }) {
  const [input, setInput] = useState('');
  const [shake, setShake] = useState(false);
  const [error, setError] = useState(false);

  const handleDigit = useCallback((digit) => {
    setInput(prev => {
      if (prev.length >= 4) return prev;
      return prev + digit;
    });
    setError(false);
  }, []);

  const handleDelete = useCallback(() => {
    setInput(prev => prev.slice(0, -1));
    setError(false);
  }, []);

  useEffect(() => {
    if (input.length === 4) {
      if (input === CORRECT_PIN) {
        onUnlock();
      } else {
        setShake(true);
        setError(true);
        setTimeout(() => {
          setShake(false);
          setInput('');
        }, 600);
      }
    }
  }, [input, onUnlock]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key >= '0' && e.key <= '9') handleDigit(e.key);
      if (e.key === 'Backspace') handleDelete();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [handleDigit, handleDelete]);

  return (
    <div className="pin-overlay">
      <div className="pin-box">
        <p className="pin-title">Emin Tavli</p>
        <p className="pin-subtitle">PIN eingeben</p>

        <div className={`pin-dots ${shake ? 'shake' : ''}`}>
          {[0, 1, 2, 3].map(i => (
            <span key={i} className={`pin-dot ${i < input.length ? 'filled' : ''} ${error ? 'error' : ''}`} />
          ))}
        </div>

        <div className="pin-pad">
          {['1','2','3','4','5','6','7','8','9','','0','⌫'].map((key, i) => (
            <button
              key={i}
              className={`pin-key ${key === '' ? 'pin-key--empty' : ''}`}
              onClick={() => key === '⌫' ? handleDelete() : key !== '' ? handleDigit(key) : null}
              disabled={key === ''}
            >
              {key}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PinLock;
